import React from "react";
import Card from "components/card";

const MetricCard = ({ label, value ,Icon, color }) => {

    return (
        <Card className={`p-4 rounded-2xl border-2 metric-card ${color}`}>
            <div className="flex items-center gap-2 mb-2">
               <div className="p-2 rounded-lg icon-bg flex-shrink-0">
                    <Icon className="w-4 h-4 icon-color" />
                </div>
                <p className="text-[11px] font-medium uppercase tracking-wide label-color">
                    {label}
                </p>
            </div>
            <p className="text-[26px] font-semibold value-color">
                {value}
            </p>
        </Card>
    )
};

export default MetricCard;